import { DealStage } from './deal-stage.enum';

export interface Approval {
  dealStage?: DealStage;
  canRequestCancellation?: boolean;
  dateTimeRequested?: string;
  dateTimeApproved?: string;
  dateTimeDeclined?: string;
  declineReason?: string;
  supplierNote?: string;
}

export interface RequestApproval {
  supplierNote?: string;
}

export enum ApprovalRequirementKey {
  InstallationDateSet = 'InstallationDateSet',
  InvoiceOrReportUploaded = 'InvoiceOrReportUploaded',
  HasAtLeastOneProduct = 'HasAtLeastOneProduct',
}

export interface ApprovalRequirementStatus {
  key: ApprovalRequirementKey;
  isMet: boolean;
}

export interface ApprovalRequirementsResponse {
  requirements: ApprovalRequirementStatus[];
}
